// extracted by mini-css-extract-plugin
module.exports = {"group":"group-_qjWo","group__label":"group__label-2YSbe"};